export default {
  "pl": {
    "ticket": {
      "actions": {
        "assignCustomer": "Zakończ procedurę",
        "close": "Zamknij",
        "new": "Nowa rozmowa",
        "reopen": "Otwórz ponownie",
        "selectResponsible": "Wybierz osobę odpowiedzialną",
        "selectUnit": "Wybierz Jednostkę",
        "show": "Pokaż"
      },
      "attributes": {
        "status": "Status",
        "statuses": {
          "closed": "Zamknięte",
          "feedback": "Czekam na informację zwrotną",
          "ongoing": "W toku",
          "open": "Otwarte"
        },
        "title": "Tytuł"
      },
      "labels": {
        "additionalQuestion": "Czy masz dodatkowe pytania?",
        "all": "Wszystko",
        "allProjects": "Wszystkie projekty",
        "allUnits": "Wszystkie jednostki",
        "clientWillRespondSoon": "{name} skontaktuje się z tobą tak szybko, jak to tylko możliwe",
        "contact": "Kontakt",
        "contactPerson": "Twoja osoba kontaktowa",
        "contactPersonWithName": "Twój kontakt ({name})",
        "conversationGroups": "Grupy dyskusyjne",
        "customer": "Klient",
        "customers": "Klienci",
        "decisionConversation": "Rozmowa dotycząca decyzji",
        "decisionConversations": "Decyzje",
        "documentAddedBy": "od:",
        "documents": "Dokumenty",
        "employee": "Pracownik",
        "export_conversation": "Eksportuj rozmowę",
        "filter": "Filtruj",
        "info": "Masz pytanie i nie widzisz adekwatnej odpowiedzi w sekcji FAQ? Zadaj je tutaj! Spróbuj podzielić pytania na przejrzyste tematy rozmów, np. „kuchnia”. ",
        "keywords": "Wyszukaj treść",
        "lastMessage": "Ostatnia wiadomość",
        "messaged_at_nulls_first_asc": "Najstarsza aktywność",
        "messaged_at_nulls_last_desc": "Ostatnia aktywność",
        "myProjects": "Moje projekty",
        "myTickets": "Moje rozmowy",
        "name_lower_asc": "Tytuł A -> Z",
        "name_lower_desc": "Tytuł Z -> A",
        "newConversation": "Nowa rozmowa",
        "newMessage": "Nowa wiadomość",
        "newMessages": "Nowe wiadomości",
        "noCustomer": "Nie przypisano ani nie zaproszono jeszcze żadnego klienta",
        "noCustomerAssignedToUnit": "Nie przypisano jeszcze żadnego klienta do tej jednostki. Czy chcesz kontynuować?",
        "noCustomerAssignedToUnitExplainer": "Uwaga: w takim przypadku należy wybrać innego odbiorcę.",
        "noMessagesYet": "Brak wiadomości",
        "noTickets": "Brak rozmów",
        "no_messages": "Brak wiadomości w rozmowie",
        "notSeenYet": "Niewyświetlone",
        "note": "Notka",
        "note_placeholder": "Pisz tylko do członków zespołu. Wpisz @, aby wspomnieć o członku zespołu, a zostanie on o tym powiadomiony.",
        "onlySelect": "Tylko pokaz",
        "orNewTicket": "Możesz też utworzyć nowe zgłoszenie na inny temat",
        "otherTickets": "Inne rozmowy",
        "partner": "Partner",
        "pendingContactPerson": "Twoja osoba kontaktowa odpowie tak szybko, jak to tylko możliwe",
        "pendingTickets": "1 nowa rozmowa do sprawdzenia | {count} nowe rozmowy do sprawdzenia",
        "project": "Projekt",
        "read": "Przeczytane",
        "reply": "Odpowiedź",
        "reply_placeholder": "Napisz do wszystkich",
        "responsible": "Osoba odpowiedzialna",
        "search": "Szukaj",
        "search_conversation": "Wyszukaj rozmowę",
        "seen": "Wyświetlone",
        "seenAll": "wszystkie",
        "seenBy": "Wyświetlone przez: {name}",
        "selectLevel": "Wybierz poziom",
        "selectUnit": "Wybierz jednostkę",
        "show": "Pokazywanie",
        "showTicketsFor": "Pokaż rozmowy dotyczące:",
        "showingAll": "Wszystkie rozmowy",
        "sort": "Sortować",
        "startConversation": "Zacznij nową rozmowę",
        "startConversationForProject": "Zacznij nową rozmowę w projekcie ",
        "startNewConversation": "Zacznij nową rozmowę",
        "subject": "Temat",
        "teamMember": "Członek zespołu",
        "ticketClosed": "Ta rozmowa została zamknięta.",
        "ticketClosedByResponsible": "Ta rozmowa została zamknięta przez: {responsible}",
        "ticketClosedCustomer": "Jeśli masz inne pytanie, utwórz nową rozmowę.",
        "ticketClosedEmployee": "Jeśli chcesz ponownie otworzyć tę rozmowę, zmień status powyżej.",
        "unit": "Jednostka",
        "unit_name_lower_asc": "Unit A -> Z",
        "unit_name_lower_desc": "Unit Z -> A",
        "unread": "Nieprzeczytane",
        "upsell": {
          "contactUs": "To jest funkcja Ziggu Expert. Skontaktuj się z nami, aby uaktualnić",
          "explainer": "Wpisz @, aby wspomnieć o członku zespołu w wewnętrznej notatce.",
          "title": "Oznacz członków swojego zespołu",
          "visibility": "Twoja notatka nie będzie widoczna dla kupującego lub partnera."
        },
        "withMentions": "Wspomniany w",
        "withMessages": "Z wiadomościami"
      },
      "navigation": {
        "backToTickets": "Wróć do rozmów"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Spróbuj podzielić pytania na ogólne tematy rozmów, np. „kuchnia”.",
            "title": "Masz pytanie? Zadaj je tutaj!"
          },
          "none": {
            "title": "Nie znaleziono rozmów"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Zacznij pierwszą rozmowę!",
            "title": "Masz pytanie?"
          },
          "none": {
            "subtitle": "Dostosuj filtry w górnej części strony lub zacznij obserwować projekt, aby wyszukać odpowiednie rozmowy",
            "title": "Nie znaleziono rozmów"
          }
        }
      },
      "validation": {
        "mustBeMaximum": "Nazwa może składać się z maksymalnie {number} znaków.",
        "needCustomer": "Wybierz klienta",
        "needName": "Należy podać tytuł",
        "needUnit": "Wybierz jednostkę"
      }
    }
  }
}
